import moment from "moment";

import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { JSXHelper } from "@/Common/Helpers/JSXHelper";
import { CommentActionType } from "@/Common/Models/MedicalRequest/Enum/CommentActionType";
import { IndividualMessageNote } from "@/Common/Models/NotesPopup/IndividualMessageNote";
import { ComboBoxDropDownItem } from "../Inputs/Combobox";

interface INotesPopup_OptimizedV2Props {
    controlId?: string;
    notes: IndividualMessageNote[];
    itemId: string;
    messageStatusId?: string;
    target?: number;
    leftPosition: number;
    topPosition: number;
    selectStatusOptions: ComboBoxDropDownItem[];
    selectedStatus: string;
    showStatusControls: boolean;
    onCancel?: () => void;
    onSave?: (note: string, itemId: string, status?: string, messageStatusId?: string) => void;
    onResize?: () => void;
    footerClassName: string;
    dataCy?: string;
}

class NotesPopup_OptimizedV2State {
    public note: string;
    public selectedStatus: string;
    public style: React.CSSProperties;
    public isDisabled: boolean;

    public static getDefault(props: INotesPopup_OptimizedV2Props): NotesPopup_OptimizedV2State {
        const state = new NotesPopup_OptimizedV2State();
        state.note = "";
        state.selectedStatus = props.selectedStatus;
        state.style = {
            left: props.leftPosition + "px",
            top: props.topPosition + "px"
        };
        state.isDisabled = true;

        return state;
    }
}

class NotesPopup_OptimizedV2 extends BaseReactComponent<INotesPopup_OptimizedV2Props, NotesPopup_OptimizedV2State> {
    private controlId: string;
    private initialStatus: string;

    public static readonly popupWidth = 600;

    constructor(props: INotesPopup_OptimizedV2Props) {
        super(props);

        this.state = NotesPopup_OptimizedV2State.getDefault(props);
        this.controlId = this.props.controlId || sessionStore.newId().toString();
        this.initialStatus = this.props.selectedStatus;
    }

    public componentDidMount(): void {
        super.setOverlay("CommunicationsNotesPopup", { transparent: true });

        this.moveThePopupAboveTabFooter();

        window.addEventListener("resize", this.resizeHandler.bind(this));
        const elem = document.getElementById("memo_doctb");
        autosize(elem);
    }

    public componentDidUpdate(nextProps: INotesPopup_OptimizedV2Props): void {
        if (this.props.notes !== nextProps.notes)
            this.moveThePopupAboveTabFooter();
    }

    public componentWillUnmount(): void {
        super.componentWillUnmount();
        $("table.myle-table tbody tr") && $("table.myle-table tbody tr").removeClass("active");
        window.removeEventListener("resize", this.resizeHandler);
        const elem = document.getElementById("memo_doctb");
        const event = document.createEvent("Event");
        event.initEvent("autosize:destroy", true, false);
        elem.dispatchEvent(event);
    }

    public moveThePopupAboveTabFooter(): void {
        // Check if we're below Rendering belong the Footer
        const footer = $("." + this.props.footerClassName);
        if (footer) {
            const elem = $(`#${this.controlId}`);
            const elemTop = this.props.topPosition;
            const elemBottom = elemTop + elem.height();
            const footerTop = footer.position().top;
            if (elemBottom > footerTop) // Reposition into the screen
                this.mutateState(s => s.style = {
                    left: `${this.props.leftPosition}px`,
                    top: `${(elemTop - (elemBottom - footerTop))}px`
                });
        }
    }

    public render(): JSX.Element {
        let content: JSX.Element = null;

        if (!this.props.notes || this.props.notes.length === 0) content = this.renderEmpty();
        else content = this.renderWithNotes();

        return (
            <div id={this.controlId} onClick={e => this.cancelClickPropagation(e)} className="notes-modal" style={this.state.style} aria-autoclose="false">
                {content}
                <div className="notes-content-footer text-right">
                    <button className="btn btn-default push-right-5" onClick={() => this.props.onCancel()} data-cy={this.props.dataCy ? `${this.props.dataCy}-cancel` : null}>{cacheStore.GetString("CancelLabel")}</button>
                    <button className="btn btn-primary" disabled={this.state.isDisabled} onClick={() => this.onSubmit()} data-cy={this.props.dataCy ? `${this.props.dataCy}-submit` : null}>{cacheStore.GetString("NoteSubmitLabel")}</button>
                </div>
            </div>
        );
    }

    private renderEmpty(): JSX.Element {
        return (
            <div className="notes-dropdown-content" data-cy={this.props.dataCy}>
                {this.props.showStatusControls === false &&
                    <h4>{cacheStore.GetString("NotesLabel").toUpperCase()}</h4>
                }
                {this.renderEditControls()}
                <textarea
                    style={{ maxHeight: "90px" }}
                    className="form-control"
                    data-cy={this.props.dataCy ? `${this.props.dataCy}-note` : null}
                    value={this.state.note}
                    id="memo_doctb"
                    onChange={(e: any) => this.onTextChange(e.target.value)}
                    rows={4}
                    autoFocus
                />
            </div>
        );
    }

    private renderEditControls(): JSX.Element {
        if (!this.props.showStatusControls) return null;

        return (
            <div className="doc-edit-container">
                <table>
                    <tbody>
                        <tr>
                            <td className="c1"><label>{cacheStore.GetString("StatusDLabel")}</label></td>
                            <td style={{ width: "80%" }}>
                                <select onChange={(e: any) => this.onStatusSelectionChange(e.target.value)} className="form-control myle-control" value={this.state.selectedStatus} data-cy={this.props.dataCy ? `${this.props.dataCy}-status` : null}>
                                    {this.props.selectStatusOptions.map((p, idx) => (
                                        <option key={"TaskViewStatusOption" + idx} value={p.Code} hidden={p.Hidden}> {cacheStore.GetLocalizedValueByLookupId(p.Code)}</option>
                                    ))}
                                </select>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }

    private renderWithNotes(): JSX.Element {
        return (
            <div className="notes-dropdown-content" data-cy={this.props.dataCy}>
                {this.renderEditControls()}
                {this.props.showStatusControls === false && <h4>{cacheStore.GetString("NotesDLabel")}</h4>}
                <div className="scroll-limit">
                    {this.props.notes.map((note: IndividualMessageNote, idx: number): JSX.Element | null => {
                        let person = null;
                        if (note.ContactId)
                            person = cacheStore.GetEmployeeByContactIdOrEmpty(note.ContactId);
                        else if (note.ContactFacetId)
                            person = cacheStore.GetEmployeeByContactFacetId(note.ContactFacetId);

                        const docPrefix = person?.PrefixLookup.GetValue();
                        return ((person) && (
                            <div key={note.Id + "_" + idx} className="notes-collection-item">
                                <div className="memo-header">
                                    <strong>{docPrefix} {person.LastName}, {person.FirstName} </strong>
                                    <span>
                                        {`${moment(note.DateCreated).format("YYYY/MM/DD")} ${cacheStore.GetString("AtLabel")} ${moment(note.DateCreated).format("HH:mm:ss")}`}
                                    </span>
                                </div>
                                <div className="note-container">
                                    {JSXHelper.BreakStringIntoParagraphs(this.getCommentBody(note))}
                                </div>
                            </div>
                        )
                        );
                    })}
                </div>
                <textarea
                    style={{ maxHeight: "90px" }}
                    className="form-control"
                    data-cy={this.props.dataCy ? `${this.props.dataCy}-note` : null}
                    value={this.state.note}
                    id="memo_doctb"
                    onChange={(e: any) => this.onTextChange(e.target.value)}
                    rows={4}
                    autoFocus
                />
            </div>
        );
    }

    private resizeHandler(): void {
        if (this.props.onResize) {
            this.props.onResize();
        }
    }

    private onTextChange(note: string): void {
        this.mutateState(s => {
            s.isDisabled = false;
            s.note = note;
        });
    }

    private onStatusSelectionChange(selectedStatus: string): void {
        this.mutateState(s => {
            if (s.selectedStatus != selectedStatus) {
                s.selectedStatus = selectedStatus;
                s.isDisabled = s.selectedStatus === this.props.selectedStatus;
            }
        });
    }

    private onSubmit(): void {
        this.props.onSave(
            this.state.note,
            this.props.itemId,
            this.initialStatus !== this.state.selectedStatus ? this.state.selectedStatus : null,
            this.initialStatus !== this.state.selectedStatus ? this.props.messageStatusId : null
        );
    }

    private cancelClickPropagation(e: React.MouseEvent): void {
        e.stopPropagation();
    }

    private getCommentBody(comment: Readonly<IndividualMessageNote>): string {
        switch (comment.ActionType) {
            case CommentActionType.SyncToPortal:
                return cacheStore.GetString("ConsultationRequestAction_SyncToPortal");

            case CommentActionType.Fax:
                return cacheStore.GetString("ConsultationRequestAction_RequestFaxed");

            case CommentActionType.Print:
                return cacheStore.GetString("ConsultationRequestAction_RequestPrinted");

            case CommentActionType.RevokeSignature:
                return cacheStore.GetString("ConsultationRequestAction_SignatureRevoked");

            case CommentActionType.MedicalRequestRecipientChange:
                return `${cacheStore.GetString("ConsultationRequestAction_RecipientUpdated")}: ${comment.Note}`;

            case CommentActionType.MedicalRequestStatusChange:
                return `${cacheStore.GetString("ConsultationRequestAction_StatusUpdated")}: ${cacheStore.GetLocalizedValueByLookupId(comment.ActionResultLookupId)}`;

            case CommentActionType.Sign:
            case CommentActionType.UserComment:
            default:
                return comment.Note;
        }
    }
}

export { NotesPopup_OptimizedV2 };
